import { isRouteErrorResponse } from "react-router";

import { ContentFetchError } from "../content/errors";
import { HighlightFetchError } from "../highlights/errors";

function isFetchError(
  error: unknown,
): error is ContentFetchError | HighlightFetchError {
  return (
    error instanceof ContentFetchError || error instanceof HighlightFetchError
  );
}

/** The API never answered: there is no HTTP status to reason about. */
export function isNetworkError(error: unknown): boolean {
  return isFetchError(error) && error.status === undefined;
}

/** A 404 in either form a route sees: a thrown Response or a domain error. */
export function isNotFound(error: unknown): boolean {
  if (isRouteErrorResponse(error)) return error.status === 404;
  return isFetchError(error) && error.status === 404;
}
